// utils/Cache.js

export class Cache {
  constructor() {
    this.cache = new Map()
    this.lastUpdated = new Map()
    this.loading = new Map()
  }

  set(key, data) {
    this.cache.set(key, data)
    this.lastUpdated.set(key, Date.now())
    this.loading.set(key, false)
  }

  async get(key, duration = 60000) {
    const lastUpdate = this.lastUpdated.get(key)
    if (!lastUpdate || Date.now() - lastUpdate > duration) {
      this.cache.delete(key)
      this.lastUpdated.delete(key)
      return null
    }
    const ret = this.cache.get(key)
    if (!ret) {
      if (this.isLoading(key)) {
        await new Promise((resolve) => {
          const checkInterval = setInterval(() => {
            if (!this.isLoading(key)) {
              clearInterval(checkInterval)
              resolve()
            }
          }, 100)
        })
        return this.cache.get(key)
      } else {
        return null
      }
    } else {
      return ret
    }
  }

  isLoading(key) {
    return this.loading.get(key) || false
  }

  clear() {
    this.cache.clear()
    this.lastUpdated.clear()
    this.loading.clear()
  }

  delete(key) {
    this.cache.delete(key)
    this.lastUpdated.delete(key)
    this.loading.delete(key)
  }
}
